import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-know-more-about-us',
  templateUrl: './know-more-about-us.component.html',
  styleUrls: ['./know-more-about-us.component.scss']
})
export class KnowMoreAboutUsComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
